// ----------------------------------------------------------------------------
// Template: Pages
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import 'sections/header/header';
import 'sections/hero-banner/hero-banner';
import 'sections/intro-block/intro-block';
import 'sections/content-panel/content-panel';
import 'sections/icon-block/icon-block';
import 'sections/banner/banner-block';
import 'sections/faqs/faqs';
import 'sections/collection-list/collection-list';
import 'sections/announcement-bar/announcement-bar';
import 'sections/content-cards/content-cards';
import 'sections/featured-collection/featured-collection';
import 'sections/blog-posts/blog-posts';
import 'sections/newsletter/newsletter';
import 'sections/page-header/page-header';
import 'sections/rich-text/rich-text';
import 'sections/video-banner/video-block';
import 'sections/featured-product/featured-product';
import 'sections/timeline/timeline';
import 'sections/press-block/press-block';
import 'sections/footer/footer';
import 'sections/quick-nav/quick-nav';
import 'sections/guarantee-bar/guarantee-bar';
import 'sections/scrolling-panel/scrolling-panel';
import 'sections/app-widget/app-widget';
import 'sections/image-gallery/image-gallery';
import 'sections/compare-products/compare-products';

// Styles
import './_pages.scss';
